export default __webpack_public_path__ + "static/media/bg6.83252345.jpg";